import { atom } from "recoil";

export const schemeIdState = atom({
  key: "schemeIdState",
  default: "",
});
